/*!

  =========================================================
  * Vue Paper Dashboard 2 PRO - v2.4.1
  =========================================================

  * Product Page: https://www.creative-tim.com/product/vue-paper-dashboard-2-pro
  * Available with purchase of license from https://www.creative-tim.com/product/vue-paper-dashboard-2-pro
  * Copyright 2022 Creative Tim (https://www.creative-tim.com)
  * License Creative Tim (https://www.creative-tim.com/license)

  =========================================================

*/
// require('dotenv').config({ path: '/.env' });
import dotenv from 'dotenv'
import Vue from "vue";
import "./pollyfills";
import VueRouter from "vue-router";
import VueNotify from "vue-notifyjs";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
import App from "./App.vue";
import store from './store'
// Plugins
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import SideBar from "./components/UIComponents/SidebarPlugin";
import initProgress from "./progressbar";
import ChartsEmbedSDK from "@mongodb-js/charts-embed-dom"

// router setup
import routes from "./routes/routes";

// dotenv.config({path: 'E:\GitHub\NodeJS-CentralGym-Dashboard\src\.env'}); // PC personal
dotenv.config({path: 'C:\NodeJS-CentralGym-Dashboard\src\.env'}); // PC Oficina
// console.log("process.env******************")
// console.log(process.env)
// library imports

const appVersion = process.env.APP_VERSION || '1.0.0';


import "./assets/sass/paper-dashboard.scss";
import 'animate.css/animate.min.css';
import "./assets/sass/demo.scss";
import { axiosLogin, MasterControlAPP, MasterControlAPI, AuthenticAPP, DownLoadsMasterControl, Operations, Env, ToDesa, XLSXTemplateDownload } from './axiosService'
import swal from "sweetalert2";
import moment from 'moment'
import PerfectScrollbar from 'perfect-scrollbar';


import sidebarLinks from "./sidebarLinks";
import "./registerServiceWorker";
// plugin setup
Vue.prototype.$axiosLogin = axiosLogin;
Vue.prototype.$MasterControlAPP = MasterControlAPP;
Vue.prototype.$MasterControlAPI = MasterControlAPI;
Vue.prototype.$XLSXTemplateDownload = XLSXTemplateDownload;
Vue.prototype.$DownLoadsMasterControl = DownLoadsMasterControl;
Vue.prototype.$AuthenticAPP = AuthenticAPP;
Vue.prototype.$Operations = Operations;
Vue.prototype.$Env = Env;
Vue.prototype.$moment = moment;
Vue.prototype.$ToDesa = ToDesa;
Vue.prototype.$ChartsSDK = ChartsEmbedSDK;
Vue.prototype.$swal = swal;
Vue.prototype.$PerfectScrollbar = PerfectScrollbar;

Vue.use(VueRouter);
Vue.use(GlobalDirectives);
Vue.use(GlobalComponents);
Vue.use(VueNotify);
Vue.use(SideBar, { sidebarLinks: sidebarLinks });
locale.use(lang);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "active",
  mode: 'history',
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  // console.log("**Env**")
  // console.log(typeof Env)
  
  // Verifica si la ruta requiere autenticación
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Verifica si el usuario está autenticado
    if (!sessionStorage.getItem('jCxbraoQeD')) {
      // console.log("login valido")
      // Si no está autenticado, redirige a la página de inicio de sesión
      next({
        path: '/login',
        // query: { redirect: to.fullPath } //Añade el destino original como query en la url
      });
    } else {
      // Si está autenticado, procede a la ruta
      if (sessionStorage.getItem('isLocked')) {
        next({
          path: '/lock',
          // query: { redirect: to.fullPath }
        });
      } else { next(); }
    }
  } else {
    // Si la ruta no requiere autenticación, procede
    next();
  }
});

initProgress(router);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
  store,
  components: {}
});
